<template>
  <div class="playing-wrap">
    <div class="playing-animation">
      <span class="jump" />
      <span class="jump" />
      <span class="jump" />
    </div>
    <p>正在播放</p>
  </div>
</template>
  
<style lang="scss" scoped>
.playing-wrap {
  flex: 1;
  height: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  .playing-animation {
    .jump {
      margin-left: 4px;
      display: inline-block;
      height: 12PX;
      width: 3PX;
      background-color: #FDCC73;
    }

    span.jump:nth-child(1) {
      animation: jump 2.1s ease-in-out infinite;
    }

    span.jump:nth-child(2) {
      animation: jump 2.1s ease-in-out -0.35s infinite;
    }

    span.jump:nth-child(3) {
      margin-right: 8PX;
      animation: jump 2.1s ease-in-out -0.7s infinite;
    }

    /* 定义动画 */
    @keyframes jump {
      0% {
        // transform:scaleY()
        height: 0;
      }

      50% {
        height: 12PX;
        // transform: translateY(-10px);
      }

      100% {
        // transform: translateY(0);
        height: 0;
      }
    }
  }

  p {
    font-size: 12PX;
    color: #ffe8ad;
  }
}
</style>
  